module.exports = __webpack_public_path__ + "static/media/icon_settings.e0394036.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon_settings.png
// module id = 458
// module chunks = 0